import React from 'react'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'

// eslint-disable-next-line turbo/no-undeclared-env-vars
const TanStackDevtools = import.meta.env.PROD
  ? () => null
  : React.lazy(() =>
      import('@tanstack/react-devtools').then((res) => ({
        default: res.TanStackDevtools
      }))
    )

export function Devtools() {
  return (
    <TanStackDevtools
      config={{ position: 'bottom-right', openHotkey: ['Shift + Control + A'] }}
      plugins={[
        { name: 'Tanstack Router', render: <TanStackRouterDevtoolsPanel /> },
        { name: 'Tanstack Query', render: <ReactQueryDevtoolsPanel /> }
      ]}
    />
  )
}
